import { IState } from '../../../../../store/types';
import { connect } from 'react-redux';
import { PhraseNotesPopup } from '../components/PhraseNotesPopup';
import { IPhraseNotesPopupEvents, IPhraseNotesPopupFields } from '../components/types';
import { PhraseNotesPopupEvents } from './events';
import { PhraseListSelectors } from '../../../../../store/phrase-list/selectors';
import { IPhraseNotesPopupHOCProps } from './types';
import { EPhrasePopupType } from '../../../../../store/phrase-list/types';
import { getMainLayoutPhrasesColumn } from '../../../../../store/general/selectors';
import { EPhrasesColumnType } from '../../../../../store/general/types';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState,
		props: IPhraseNotesPopupHOCProps,
	): IPhraseNotesPopupFields => {
		const { type } = props;

		const phrasePopup = PhraseListSelectors.getPhrasePopup(state);
		const isShow = PhraseListSelectors.getIsNotePopup(state) && (
			// !phrasePopup && type === EPhrasePopupType.CAPTIONS || // edit note from saved
			phrasePopup && phrasePopup === type ||
			type === EPhrasePopupType.CAPTIONS && getMainLayoutPhrasesColumn(state) === EPhrasesColumnType.COLUMNS_2
		);
		return {
			isShow,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any
): IPhraseNotesPopupEvents => {
	return {
		onClose: () => dispatch(PhraseNotesPopupEvents.onClose()),
	}
}

export const PhraseNotesPopupHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(PhraseNotesPopup) as any;

PhraseNotesPopupHOC.displayName = 'PhraseNotesPopupHOC';
